var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container"},[_c('div',{staticClass:"header"},[_c('img',{attrs:{"src":require("@/assets/images/public/head-back-black-icon.png"),"alt":""},on:{"click":_vm.back}})]),_c('div',{staticClass:"iframe-container"},[_c('iframe',{attrs:{"id":"iframe","width":"100%","height":"100%","src":_vm.url,"frameborder":"0"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }